import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Video } from 'components/ui';
import { MediaType } from 'types/AbstractMedia';

import BadgeWrapper from './BadgeWrapper';
import { getKioskVideoGuide } from 'modules/dealers/selectors';
import { useSelector } from 'hooks';

type QrCodePanelProps = {
  onClick: () => void;
  badgeLabel: React.ReactNode;
};

const QrCodePanel: React.FC<QrCodePanelProps> = ({ badgeLabel, onClick }) => {
  const videoGuide = useSelector(getKioskVideoGuide);
  return (
    <BadgeWrapper badgeLabel={badgeLabel} testId="qr-panel">
      <button
        type="button"
        onClick={onClick}
        data-testid="qr-video-card"
        className="relative flex-1 h-full rounded-card overflow-hidden w-full text-left"
      >
        <div className="absolute inset-0 [&_video]:h-full [&_video]:w-full [&_video]:object-cover">
          <div className="absolute inset-0 bg-black/30" />
          <Video
            loop
            muted
            autoPlay
            controls={false}
            media={{ path: videoGuide!, type: MediaType.VIDEO }}
          />
        </div>

        <div className="absolute bottom-1/2 translate-y-1/2 text-white text-center w-full">
          <div className="font-semibold text-s">
            <FormattedMessage id="login.qrPanel.title" defaultMessage="I have my QR code" />
          </div>
          <div className="text-xs mt-1">
            <FormattedMessage id="login.qrPanel.subtitle" defaultMessage="Scan it at the kiosk to continue." />
          </div>
        </div>
      </button>
    </BadgeWrapper>
  );
};

export default QrCodePanel;
